// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"929f1aa2","896":"6ffc37e1"}[chunkId] + ".chunk.js";
};